import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHelium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconHelium"><Path d="M14.016 21.0113L11.9963 22.5002L9.97665 21.0113L10.8944 13.9071L5.19165 18.2526L2.89062 17.2501L3.17159 14.7592L9.79191 12L3.17159 9.24081L2.89062 6.74988L5.19165 5.74743L10.8944 10.0929L9.97665 2.98866L11.9963 1.49976L14.016 2.98866L13.0982 10.0929L18.801 5.74743L21.102 6.74988L20.821 9.24081L14.2007 12L20.821 14.7592L21.102 17.2501L18.801 18.2526L13.0982 13.9071L14.016 21.0113Z" fill="currentColor"/></CentralIconBase>;
});

export default IconHelium;
